import WithGASetup from '../../components/WithGASetup';
import AuthContext from '../../context/AuthContext';
import FormAsessmentPage from './FormAsessmentPage';

export default WithGASetup(FormAsessmentPage, AuthContext);
